import { __read, __assign, __spreadArray } from 'tslib';
import useLatest from '../node_modules/.pnpm/ahooks@3.7.11_react@18.2.0/node_modules/ahooks/es/useLatest/index.js';
import useRequest from '../node_modules/.pnpm/ahooks@3.7.11_react@18.2.0/node_modules/ahooks/es/useRequest/src/useRequest.js';
import debounce from '../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/debounce.js';
import differenceWith from '../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/differenceWith.js';
import get from '../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/get.js';
import isPlainObject from '../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isPlainObject.js';
import { useState } from 'react';

var COUNT = 100;
var DEBOUNCE_WAIT = 300;
var useRemoteSearch = function (_a) {
    var searchFn = _a.searchFn, _b = _a.debounceWait, debounceWait = _b === void 0 ? DEBOUNCE_WAIT : _b, _c = _a.listKey, listKey = _c === void 0 ? 'list' : _c, queryKey = _a.queryKey, extraParams = _a.extraParams, transformer = _a.transformer, initOptions = _a.initOptions, count = _a.count, _d = _a.dropdownLoading, dropdownLoading = _d === void 0 ? true : _d, showLoading = _a.showLoading;
    var firstOptions = [];
    if (Array.isArray(initOptions)) {
        firstOptions = initOptions;
    }
    else if (isPlainObject(initOptions)) {
        // @ts-expect-error
        var data_1 = initOptions.data, labelKey = initOptions.labelKey, valueKey_1 = initOptions.valueKey;
        if (!valueKey_1 || !labelKey)
            throw new Error('valueKey and labelKey are required when initOptions.data is provided');
        if (data_1[valueKey_1] && typeof data_1[valueKey_1] === 'string') {
            data_1[labelKey].split(',').forEach(function (name, index) {
                var value = data_1[valueKey_1].split(',')[index];
                firstOptions.push({
                    label: name,
                    value: isNaN(+value) ? value : +value,
                });
            });
        }
        else if (data_1[valueKey_1] && Array.isArray(data_1[valueKey_1])) {
            // @example: data[labelKey]: "station_name1,station_name2,station_name3"
            data_1[labelKey].split(',').forEach(function (name, index) {
                firstOptions.push({
                    label: name,
                    value: data_1[valueKey_1][index],
                });
            });
        }
        else if (data_1[valueKey_1]) {
            firstOptions = [
                {
                    label: data_1[labelKey],
                    value: data_1[valueKey_1],
                },
            ];
        }
    }
    var _e = __read(useState(firstOptions), 2), options = _e[0], setOptions = _e[1];
    var initParams = useLatest(__assign({ count: count || COUNT }, extraParams));
    var _f = useRequest(searchFn, {
        manual: true,
        onSuccess: function (data) {
            var _a;
            var list = (_a = get(data, listKey)) !== null && _a !== void 0 ? _a : [];
            var transformList = (transformer === null || transformer === void 0 ? void 0 : transformer(list)) || list;
            var needAddList = firstOptions.length
                ? differenceWith(transformList, firstOptions, function (a, b) { return a.value === b.value; })
                : [];
            var finalList = needAddList.concat.apply(needAddList, __spreadArray([], __read(transformList), false));
            setOptions(finalList);
        },
        onError: function (e) {
            console.error(e);
        },
    }), loading = _f.loading, error = _f.error, run = _f.run;
    var handleQuerySearch = function (val) {
        var _a;
        if (!queryKey)
            throw new Error('queryKey is required when have search string');
        // 兼容性写法
        (dropdownLoading || showLoading) && setOptions([]);
        run(__assign(__assign({}, initParams.current), (val ? (_a = {}, _a[queryKey] = val, _a) : null)));
    };
    var handleDebounceQuerySearch = debounce(handleQuerySearch, debounceWait);
    var handleDropdownVisibleChange = function (open) {
        if (!open)
            return;
        run(initParams.current);
        // 兼容性写法
        (dropdownLoading || showLoading) && setOptions([]);
    };
    return {
        options: options,
        setOptions: setOptions,
        loading: loading,
        error: error,
        handleDropdownVisibleChange: handleDropdownVisibleChange,
        handleQuerySearch: handleQuerySearch,
        handleDebounceQuerySearch: handleDebounceQuerySearch,
    };
};

export { useRemoteSearch as default };
